define('helperLayout-isMissing',[],function() {
    'use strict';

    var isMissing = function(elements, components) {
        var arr = [];

        if (!elements || !Object.keys(elements).length || !Array.isArray(components)) {
            return false;
        }

        for (var prop in elements) {
            if (prop) {
                arr.push(prop.toLowerCase());
            }
        }

        for (var i = 0; i < components.length; i++) {
            if (components[i].templateID && arr.indexOf(components[i].kind) === -1) {
                return true;
            }
        }

        return false;
    };

    return isMissing;
});

